import { Alert, AlertIcon, Button, Icon, Stack, Text } from "@chakra-ui/react";
import { skipToken } from "@reduxjs/toolkit/query";
import { useTranslation } from "react-i18next";
import { FiExternalLink } from "react-icons/fi";
import { Link as RouterLink } from "react-router-dom";
import { useGetMarketDialogueQuery, type SourcingEventDto } from "../../../../../autogen/bff-api";
import { urls } from "../../../../../urls";

export const MarketDialogueOriginNotice = ({ event }: { event: SourcingEventDto }) => {
  const { t } = useTranslation();
  const marketDialogueId = event.fromMarketDialogueId;
  const { data: dialogue, isError } = useGetMarketDialogueQuery(marketDialogueId ? { marketDialogueId } : skipToken);
  if (!marketDialogueId || (!dialogue && !isError)) return null;

  return (
    <Alert status="info" borderRadius="md" mt="4" alignItems="flex-start" data-testid="market-dialogue-origin-notice">
      <AlertIcon />
      <Stack spacing="2" flex="1" minW="0" fontSize="sm">
        <Text>
          {dialogue
            ? t("Created from the market dialogue «{{title}}».", { title: dialogue.title.trim() || t("Untitled") })
            : t("Created from a market dialogue.")}
        </Text>
        {dialogue && (
          <Button
          as={RouterLink}
          to={urls.app.marketDialogues.view.go(dialogue.id)}
          target="_blank"
          variant="link"
          size="sm"
          alignSelf="flex-start"
          colorScheme="teal"
          rightIcon={<Icon as={FiExternalLink} />}
        >
          {t("Open the market dialogue")}
          </Button>
        )}
      </Stack>
    </Alert>
  );
};
